<!-- 年度各区域农机报废补贴额 -->
<template>
  <div :id="id" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    id: {
      type: String,
      default: "rightThirdchart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          year: [],
          // 使用比例
          useRatio: [],
          // 结算比例
          settlementRatio: [],
        }
      }
    },
  },
  data() {
    return {
      chart: null,
      // 立体柱状图颜色
      colorArr: [['rgba(7, 125, 68, ', 'rgba(25, 218, 125, '],['rgba(4, 93, 50, ','rgba(3, 117, 62, '], ['rgba(125, 125, 6, ', 'rgba(217, 217, 24, '],['rgba(92, 62, 4, ','rgba(117, 117, 4, ']],
      options: {
        // tooltip: {
        //     trigger: 'axis',
        //     axisPointer: {
        //         type: 'shadow'
        //     }
        // },
        legend: {
          data: ['使用比例', '结算比例'],
          orient: 'horizontal',
          icon: 'none',
          textStyle: {
            rich: {
              a: { color: '#0DFF8A', padding: [0, 24, 0, 0]},  // 左图例项左对齐
              b: { color: '#FFFF0D', padding: [0, 40, 0, 0]}  // 右图例项右对齐
            }
          },
          formatter: function (name) {
            return name === '使用比例' ? '{a|' + name + '}' : '{b|' + name + '}';
          }
        },
        grid: [
          {
            top: '14%',
            bottom: '10%',
            left: '10%',
            width: '32%'
          },
          {
            top: '14%',
            bottom: '10%',
            left: '56%',
            width: '32%'
          }
        ],
        xAxis: [
          {
            gridIndex: 0,
            type: 'value',
            inverse: true, 
            axisTick: {
              show: false,
            },
            axisLabel: {
              // interval: 1,
              color: '#BABBBD',
              fontSize: 12,
              margin: -1,
              // formatter: '{value}%'
              formatter: (value, index) => index % 2 === 0 ? value + '%' : '', // 每隔一个显示
            },
            splitLine: false,
            axisLine: {
              show: false,
            },
          },
          {
            gridIndex: 1,
            type: 'value',
            axisTick: {
              show: false,
            },
            axisLabel: {
              // interval: 1,
              color: '#BABBBD',
              fontSize: 12,
              margin: -1,
              // formatter: '{value}%'
              formatter: (value, index) => index % 2 === 0 ? value + '%' : '', // 每隔一个显示
            },
            splitLine: false,
            axisLine: {
              show: false,
            },
          }
        ],
        yAxis: [
          {
            gridIndex: 0,
            type: 'category',
            show: true,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(88, 252, 146, 0.17)',
                width: 2,
              }
            }
          },
          {
            gridIndex: 1,
            type: 'category',
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: '#BABBBD',
              fontSize: 12,
              margin: 20,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(88, 252, 146, 0.17)',
                width: 2,
              }
            }
          }
        ],
      }
 
    };
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 300);
    });
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
    setChartData() {
      this.options.yAxis[1].data = this.chartData.year;
      let series = [];
      let that = this;
      // 左侧立体柱状图上
      series.push(
        {
          name: '使用比例',
          type: 'bar',
          barGap: 0,
          barWidth: '3',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: that.chartData.useRatio,
          label: {
            show: true, 
            padding: [12,0,0,-5],
            position: 'left',
            color: '#FFFFFF',
            formatter: function(params) {
              if (params.value > 0) {
                  return params.value + '%';
              } else {
                  return '';
              }
            }
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return  new echarts.graphic.LinearGradient(0,0,1,0, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[1][1] + '0.9)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[1][0] + '0.9)',
                    },
                  ]
                );
              }
            },
          },
      });
      // 左侧立体柱状图下
      series.push(
        {
          type: 'bar',
          barGap: 0,
          barWidth: '9',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: that.chartData.useRatio,
          itemStyle: {
            normal: {
              color: function(params) {
                return  new echarts.graphic.LinearGradient(0,0,1,0, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[0][1] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[0][0] + '1)',
                    },
                  ]
                );
              }
            },
          },
        },
      );
      // 右侧立体柱状图上
      series.push(
        {
          name: '结算比例',
          type: 'bar',
          barGap: 0,
          barWidth: '3',
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: that.chartData.settlementRatio,
          label: {
            show: true, 
            padding: [12,0,0,3],
            position: 'right',
            color: '#FFFFFF',
            formatter: function(params) {
              if (params.value > 0) {
                  return params.value + '%';
              } else {
                  return '';
              }
            }
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return  new echarts.graphic.LinearGradient(1,0,0,0, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[3][1] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[3][0] + '1)',
                    },
                  ]
                );
              }
            },
          },
      });
      // 右侧立体柱状图下
      series.push(
        {
          type: 'bar',
          barGap: 0,
          barWidth: '9',
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: that.chartData.settlementRatio,
          itemStyle: {
            normal: {
              color: function(params) {
                return  new echarts.graphic.LinearGradient(1,0,0,0, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[2][1] + '0.9)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[2][0] + '0.9)',
                    },
                  ]
                );
              }
            },
          },
        },
      );
      // 右边最下面菱形
      series.push(
        {
          data: that.chartData.settlementRatio,
          xAxisIndex: 1,
          yAxisIndex: 1,
          type: 'pictorialBar',
          symbol: 'diamond',
          symbolSize: [6.8, 12],
          symbolPosition: 'end',
          symbolOffset: [4, 0],
          itemStyle: {
            normal: {
              color: function(params) {
                return that.colorArr[2][1] + '1)';
              }
            },
          }
        }
      );
      this.options.series = series;
      this.chart.setOption(this.options);
    },
  },
};
</script>
